<template>
	<div class="subHeader">
		<slot></slot>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
	name: "SubHeader",
	props: {
		helpPageName: {
			type: String,
			required: false,
		},
	},
	components: {},
	mounted() { },
	methods: {},
	computed: {},
})
</script>

<style scoped>
.subHeader {
	font-size: 1.125rem;
	line-height: 1.75rem;
	font-weight: 500;
}
</style>
